import { useBankProfile } from '@contexts/BankProfileContext';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import type { CreatePaymentTemplate } from 'types/templates';

import { useAuth } from './useAuth';

export const useTemplateDetails = (templateId?: string | null) => {
	const { session } = useAuth();
	const { selectedProfile } = useBankProfile();

	const getTemplateDetails = async () => {
		const response = await axios.get<CreatePaymentTemplate & { uuid: string }>(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile?.id}/payment-templates/${templateId}`,
			{
				headers: { Authorization: session?.tokenized },
			},
		);

		if (response.data?.amount) {
			response.data.amount = response.data.amount / 100;
		}

		return response.data;
	};

	return useQuery({
		queryKey: ['templates', templateId, selectedProfile],
		queryFn: getTemplateDetails,
		enabled: !!session?.tokenized && !!selectedProfile?.id && !!templateId,
	});
};
